import { Component } from '@theme/component';
import EmblaCarousel, {
  EmblaCarouselType,
  EmblaOptionsType,
} from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

class RhmCarouselComponent extends Component {
  #emblaApi: EmblaCarouselType | null = null;

  connectedCallback() {
    super.connectedCallback();
    this.#init();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#emblaApi?.destroy();
    this.#emblaApi = null;
  }

  scrollPrev() {
    this.#emblaApi?.scrollPrev();
  }

  scrollNext() {
    this.#emblaApi?.scrollNext();
  }

  #init() {
    const viewport = this.refs.viewport as HTMLElement | undefined;
    if (!viewport) return;

    const dragFree = this.dataset.dragFree !== 'false';
    const loop = this.dataset.loop === 'true';

    const options: EmblaOptionsType = {
      align: 'start',
      dragFree,
      loop,
      containScroll: 'trimSnaps',
    };

    const plugins = [WheelGesturesPlugin()];

    if (this.dataset.autoScroll === 'true') {
      const speed = parseFloat(this.dataset.autoScrollSpeed || '2');
      plugins.push(
        AutoScroll({
          speed,
          stopOnInteraction: false,
          stopOnMouseEnter: true,
          playOnInit: true,
        }) as any
      );
    }

    this.#emblaApi = EmblaCarousel(viewport, options, plugins as any);

    const onSelect = () => {
      this.#updateButtons();
      this.#updateSnapDisplay();
    };

    this.#emblaApi.on('select', onSelect).on('reInit', onSelect);
    onSelect();
  }

  #updateButtons() {
    if (!this.#emblaApi) return;
    const prevBtn = this.refs.prevBtn as HTMLButtonElement | undefined;
    const nextBtn = this.refs.nextBtn as HTMLButtonElement | undefined;
    if (prevBtn) prevBtn.disabled = !this.#emblaApi.canScrollPrev();
    if (nextBtn) nextBtn.disabled = !this.#emblaApi.canScrollNext();
  }

  #updateSnapDisplay() {
    if (!this.#emblaApi) return;
    const snapDisplay = this.refs.snapDisplay as HTMLElement | undefined;
    if (!snapDisplay) return;
    const current = this.#emblaApi.selectedScrollSnap() + 1;
    const total = this.#emblaApi.scrollSnapList().length;
    snapDisplay.textContent = `${current} / ${total}`;
  }
}

if (!customElements.get('rhm-carousel-component')) {
  customElements.define('rhm-carousel-component', RhmCarouselComponent);
}
